import { SiChakraui } from 'react-icons/si';

import { dbDateTimeToDisplayString } from '../../../../commons/common';
import { FAPPMonitor } from '../../../../models/AdminApplicationServer';

type Column = {
    key: string;
    text: string;
    className: string;
    sortable: boolean;
    cell: (record: FAPPMonitor, index: number) => React.JSX.Element;
};

export const fappMonitorColumns: Column[] = [
    {
        key: 'status',
        text: 'Status',
        className: 'Status flex justify-center',
        sortable: true,
        cell: (record, index) => {
            return (
                <SiChakraui
                    style={{
                        textAlign: 'center',
                        color: record.status === false ? 'red' : 'green'
                    }}
                />
            );
        }
    },
    {
        key: 'updateOn',
        text: 'Last Status',
        className: 'LastStatus',
        sortable: true,
        cell: (record, index) => {
            return (
                <div
                    style={{
                        textAlign: 'center'
                    }}
                >
                    {dbDateTimeToDisplayString(record.updatedOn)}
                </div>
            );
        }
    },
    {
        key: 'name',
        text: 'Name',
        className: 'text-left',
        sortable: true,
        cell: (record, index) => <div>{record.name}</div>
    },
    {
        key: 'port',
        text: 'Port',
        className: 'text-center',
        sortable: true,
        cell: (record, index) => <div>{record.port}</div>
    }
];
